import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { EmailTemplate } from '../../../types/EmailTemplate';

export const fetchEmailTemplate = async (uuid: string | undefined) => {
  if (uuid === undefined) return null;
  
  const response = await CustomAxios.get<EmailTemplate>(`email_templates/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetEmailTemplateByIdProps {
  uuid?: string;
}
export function useGetEmailTemplateById({ uuid }: UseGetEmailTemplateByIdProps) {
  const query = useQuery({
    queryKey: [queryKeys.allEmailTemplates, uuid],
    queryFn: () => fetchEmailTemplate(uuid)
  });

  return query;
}
